module.exports = __webpack_public_path__ + "img/logo.c5dddff0.png";